export default {"src":"/_next/static/media/linux.08c3ade3.svg","height":48,"width":155,"blurWidth":0,"blurHeight":0};